import { render, staticRenderFns } from "./yearViewDetail.vue?vue&type=template&id=5a6c51a2&scoped=true"
import script from "./yearViewDetail.vue?vue&type=script&lang=js"
export * from "./yearViewDetail.vue?vue&type=script&lang=js"
import style0 from "./yearViewDetail.vue?vue&type=style&index=0&id=5a6c51a2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6c51a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a6c51a2')) {
      api.createRecord('5a6c51a2', component.options)
    } else {
      api.reload('5a6c51a2', component.options)
    }
    module.hot.accept("./yearViewDetail.vue?vue&type=template&id=5a6c51a2&scoped=true", function () {
      api.rerender('5a6c51a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherMatch/yearViewDetail.vue"
export default component.exports